package no.vareflow.app.sync

import no.vareflow.app.domain.nowMillis

/*
 * Data exchanged between the app and the Firestore count-sync layer.
 * Pure Kotlin: no Firebase or Android types, so the sync decisions built on them can be unit tested.
 */

data class PendingCountWrite(
    val eventId: String,
    val companyId: String,
    val locationId: String,
    val sessionId: String,
    val productId: String,
    val departmentId: String = "bar",
    val quantity: Double?,
    val note: String,
    val actorUserId: String,
    val actorName: String,
    val baseVersion: Int,
    val createdAt: Long,
    val resolutionOfConflictId: String? = null
)

data class RemoteCountEntry(
    val sessionId: String,
    val productId: String,
    val departmentId: String = "bar",
    val quantity: Double?,
    val note: String,
    val updatedBy: String,
    val updatedAt: Long,
    val version: Int,
    val lastEventId: String?
)

/** A queued count write that the server rejected permanently (e.g. permission denied). */
data class RejectedCountWrite(
    val write: PendingCountWrite,
    val reason: String,
    val rejectedAt: Long = nowMillis()
)

data class CountConflict(
    val id: String,
    val sessionId: String,
    val productId: String,
    val departmentId: String = "bar",
    val productName: String,
    val localQuantity: Double?,
    val localNote: String,
    val localActorId: String,
    val localActorName: String,
    val localBaseVersion: Int,
    val remoteQuantity: Double?,
    val remoteNote: String,
    val remoteActorId: String,
    val remoteVersion: Int,
    val eventId: String,
    val createdAt: Long
)
